import * as types from "./actionTypes";
import Entity from "src/modules/organization/models/Entity";

export const loadEntity = () => {
  return { type: types.LOAD_ENTITY };
}

export const loadEntitySuccess = (entity: Entity) => {
  return { type: types.LOAD_ENTITY_SUCCESS, payload: entity };
}



// WEBPACK FOOTER //
// ./src/modules/core/actions/entityActions.tsx